// // 📂 ProductTable.tsx
// import React, { useEffect, useState } from 'react';
// import {
// 	Box,
// 	Paper,
// 	Chip,
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableContainer,
// 	TableHead,
// 	TableRow,
// 	Link,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import MySearchInputs from '../../Vendor-ui/SearchInputs';
// import { MyModal } from '../../Vendor-ui/Modal';
// import { ProductApprovel } from '../../../../../services/api/Vendorpage/approverproduct';
// import MySnackbarModal from '../../Vendor-ui/SnackbarModal';

// const rowVariants = {
// 	hidden: { opacity: 0, y: 10 },
// 	visible: (i: number) => ({
// 		opacity: 1,
// 		y: 0,
// 		transition: { delay: i * 0.05 },
// 	}),
// };

// interface ProductTableProps {
// 	theme: any;
// 	requests: any[];
// 	searchTerm: string;
// 	setSearchTerm: (v: string) => void;
// 	fetchProducts: () => Promise<void>;
// 	navigate: any;
// }

// export default function ProductTable({
// 	theme,
// 	requests,
// 	searchTerm,
// 	setSearchTerm,
// 	fetchProducts,
// 	navigate,
// }: ProductTableProps) {
// 	console.log(requests, 'test2');

// 	const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
// 	const [openDialog, setOpenDialog] = useState(false);
// 	const [loader, setLoader] = useState(false);
// 	const [currentAction, setCurrentAction] = useState<{
// 		id?: string;
// 		action?: 'approve' | 'reject';
// 	} | null>(null);
// 	const [actionModal, setActionModal] = useState<any>(null);
// 	const [productPercentage, setProductPercentage] = useState(null);
// 	const [snackbar, setSnackbar] = useState<{
// 		open: boolean;
// 		message: string;
// 		severity: 'approve' | 'reject';
// 	}>({
// 		open: false,
// 		message: '',
// 		severity: 'approve',
// 	});

// 	useEffect(() => {
// 		let result = [...requests];
// 		if (searchTerm) {
// 			const term = searchTerm.toLowerCase();
// 			result = result.filter(
// 				(req) =>
// 					req.company.toLowerCase().includes(term) ||
// 					req.contactPerson.toLowerCase().includes(term) ||
// 					req.contactEmail.toLowerCase().includes(term) ||
// 					req.phone.toLowerCase().includes(term) ||
// 					req.businessType.toLowerCase().includes(term) ||
// 					req.name.toLowerCase().includes(term) ||
// 					req.id.toLowerCase().includes(term)
// 			);
// 		}
// 		setFilteredRequests(result);
// 	}, [searchTerm, requests]);

// 	const handleActionClick = (id: string, action: 'approve' | 'reject') => {
// 		setCurrentAction({ id, action });
// 		setActionModal(action);
// 		setOpenDialog(true);
// 	};

// 	const handleCancelAction = () => {
// 		setOpenDialog(false);
// 		setCurrentAction(null);
// 	};

// 	const handleApprovalAction = async (reason?: string) => {
// 		if (!currentAction) return;
// 		try {
// 			setLoader(true);
// 			const payload = {
// 				action: currentAction.action,
// 				reason,
// 				productPercentage: productPercentage,
// 			};
// 			const response = await ProductApprovel(
// 				`admin/product/vendor/${currentAction?.id}/products`,
// 				payload
// 			);

// 			if (response.success) {
// 				setSnackbar({
// 					open: true,
// 					message: `Product ${currentAction.action} successfully`,
// 					severity: 'approve',
// 				});
// 				await fetchProducts();
// 				setOpenDialog(false);
// 				setCurrentAction(null);
// 			} else {
// 				setOpenDialog(false);
// 				setSnackbar({
// 					open: true,
// 					message: response?.message || 'Action failed',
// 					severity: 'reject',
// 				});
// 			}
// 		} catch (err) {
// 			console.error('Approval error:', err);
// 			setSnackbar({
// 				open: true,
// 				message: 'Something went wrong while processing action',
// 				severity: 'reject',
// 			});
// 		} finally {
// 			setLoader(false);
// 		}
// 	};

// 	return (
// 		<>
// 			<Box sx={{ py: 2 }}>
// 				<MySearchInputs searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
// 			</Box>

// 			<TableContainer component={Paper} sx={{ maxHeight: 400 }}>
// 				<Table stickyHeader>
// 					<TableHead sx={{ bgcolor: theme.palette.grey[100] }}>
// 						<TableRow>
// 							<TableCell>ID</TableCell>
// 							<TableCell>Company </TableCell>
// 							<TableCell>Company Type</TableCell>
// 							<TableCell>Email</TableCell>
// 							<TableCell>Phone </TableCell>
// 							<TableCell>Submitted</TableCell>
// 							<TableCell>Status</TableCell>
// 							<TableCell>Actions</TableCell>
// 						</TableRow>
// 					</TableHead>
// 					<TableBody>
// 						{filteredRequests.length > 0 ? (
// 							filteredRequests.map((req, i) => (
// 								<motion.tr
// 									key={req.id}
// 									custom={i}
// 									initial="hidden"
// 									animate="visible"
// 									variants={rowVariants}
// 									style={{ display: 'table-row' }}
// 								>
// 									<TableCell>
// 										<Link href={`/vendor/product/view/${req.slug}`}>
// 											{req.id}
// 										</Link>
// 									</TableCell>
// 									<TableCell>
// 										{req.createdByModel === 'Vendor' ? req.company : req.name}
// 									</TableCell>
// 									<TableCell>
// 										{req.createdByModel === 'Vendor'
// 											? req.contactPerson
// 											: `₹${req.price}`}
// 									</TableCell>
// 									<TableCell>{req.contactEmail}</TableCell>
// 									<TableCell>
// 										{req.createdByModel === 'Vendor' ? req.phone : req.status}
// 									</TableCell>
// 									<TableCell>{req.submitted}</TableCell>
// 									<TableCell>
// 										<Chip
// 											label={req.productApprovelStatus}
// 											size="small"
// 											sx={{
// 												bgcolor:
// 													req.productApprovelStatus === 'APPROVED'
// 														? 'success.main'
// 														: '#e60f0fff',
// 												color: '#ffffffff',
// 												fontWeight: 500,
// 												textTransform: 'capitalize',
// 											}}
// 										/>
// 									</TableCell>
// 									<TableCell>
// 										<Box sx={{ display: 'flex', gap: 1 }}>
// 											{(req.productApprovelStatus as any) !== 'APPROVED' && (
// 												<Chip
// 													label={'Approve'}
// 													size="small"
// 													onClick={() =>
// 														navigate(`/vendor/product/view/${req.slug}`)
// 													}
// 													sx={{
// 														bgcolor: '#6EE7B7',
// 														color: '#065F46',
// 														cursor: 'pointer',
// 														fontWeight: 500,
// 														textTransform: 'capitalize',
// 														'&:hover': {
// 															bgcolor: 'success.main',
// 															color: 'white',
// 														},
// 													}}
// 												/>
// 											)}
// 											{(req.productApprovelStatus as any) !== 'Rejected' && (
// 												<Chip
// 													label="Reject"
// 													size="small"
// 													onClick={() =>
// 														handleActionClick(req._id, 'reject')
// 													}
// 													sx={{
// 														bgcolor: '#F9A8D4',
// 														color: '#9D174D',
// 														cursor: 'pointer',
// 														fontWeight: 500,
// 														'&:hover': {
// 															bgcolor: 'error.main',
// 															color: 'white',
// 														},
// 													}}
// 												/>
// 											)}
// 										</Box>
// 									</TableCell>
// 								</motion.tr>
// 							))
// 						) : (
// 							<TableRow>
// 								<TableCell colSpan={7} sx={{ textAlign: 'center', py: 4 }}>
// 									No products found
// 								</TableCell>
// 							</TableRow>
// 						)}
// 					</TableBody>
// 				</Table>
// 			</TableContainer>

// 			<MyModal
// 				loader={loader}
// 				open={openDialog}
// 				onClose={handleCancelAction}
// 				action={actionModal}
// 				onConfirm={handleApprovalAction}
// 				per={setProductPercentage}
// 			/>

// 			<MySnackbarModal
// 				open={snackbar.open}
// 				Message={snackbar.message}
// 				action={snackbar.severity}
// 				onClose={() => setSnackbar({ ...snackbar, open: false })}
// 				// position={{ vertical: 'bottom', horizontal: 'right' }}
// 			/>
// 		</>
// 	);
// }
import React, { useEffect, useState } from 'react';
import {
	Box,
	Paper,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Link,
} from '@mui/material';
import { motion } from 'framer-motion';
import MySearchInputs from '../../Vendor-ui/SearchInputs';
import { MyModal } from '../../Vendor-ui/Modal';
import { ProductApprovel } from '../../../../../services/api/Vendorpage/approverproduct';
import MySnackbarModal from '../../Vendor-ui/SnackbarModal';

const rowVariants = {
	hidden: { opacity: 0, y: 10 },
	visible: (i: number) => ({
		opacity: 1,
		y: 0,
		transition: { delay: i * 0.05 },
	}),
};

interface ProductTableProps {
	theme: any;
	requests: any[];
	searchTerm: string;
	setSearchTerm: (v: string) => void;
	fetchProducts: () => Promise<void>;
	// navigate?: any;
}

export default function ProductTable({
	theme,
	requests,
	searchTerm,
	setSearchTerm,
	fetchProducts,
}: ProductTableProps) {
	const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
	const [vendorApprove, setVendorApprove] = useState(null);
	const [openDialog, setOpenDialog] = useState(false);
	const [loader, setLoader] = useState(false);
	const [currentAction, setCurrentAction] = useState<{
		id?: string;
		action?: 'approve' | 'reject';
	} | null>(null);
	const [actionModal, setActionModal] = useState<any>(null);
	const [snackbar, setSnackbar] = useState<{
		open: boolean;
		message: string;
		severity: 'approve' | 'reject';
	}>({
		open: false,
		message: '',
		severity: 'approve',
	});

	useEffect(() => {
		let result = [...requests];
		if (searchTerm) {
			const term = searchTerm.toLowerCase();
			result = result.filter(
				(req) =>
					req.company.toLowerCase().includes(term) ||
					req.contactPerson.toLowerCase().includes(term) ||
					req.contactEmail.toLowerCase().includes(term) ||
					req.phone.toLowerCase().includes(term) ||
					req.businessType.toLowerCase().includes(term) ||
					req.name.toLowerCase().includes(term) ||
					req.id.toLowerCase().includes(term)
			);
		}
		setFilteredRequests(result);
	}, [searchTerm, requests]);

	const handleActionClick = (id: string, action: 'approve' | 'reject', req: any) => {
		setCurrentAction({ id, action });
		setVendorApprove(req);
		setActionModal(action);
		setOpenDialog(true);
	};

	const handleCancelAction = () => {
		setOpenDialog(false);
		setCurrentAction(null);
	};

	// ✅ Now handles both reason and percentage
	const handleApprovalAction = async (reason?: string, percentage?: number) => {
		if (!currentAction) return;
		try {
			setLoader(true);
			const payload = {
				action: currentAction.action,
				reason,
				productPercentage: percentage,
			};
			const response = await ProductApprovel(
				`admin/product/vendor/${currentAction?.id}/products`,
				payload
			);

			if (response.success) {
				setSnackbar({
					open: true,
					message: `Product ${currentAction.action} successfully`,
					severity: 'approve',
				});
				fetchProducts();
				setOpenDialog(false);
				setCurrentAction(null);
			} else {
				setOpenDialog(false);
				setSnackbar({
					open: true,
					message: response?.message || 'Action failed',
					severity: 'reject',
				});
			}
		} catch (err) {
			console.error('Approval error:', err);
			setSnackbar({
				open: true,
				message: 'Something went wrong while processing action',
				severity: 'reject',
			});
		} finally {
			setLoader(false);
		}
	};

	return (
		<>
			<Box sx={{ py: 2 }}>
				<MySearchInputs searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
			</Box>

			<TableContainer component={Paper} sx={{ maxHeight: 400 }}>
				<Table stickyHeader>
					<TableHead sx={{ bgcolor: theme.palette.grey[100] }}>
						<TableRow>
							<TableCell>ID</TableCell>
							<TableCell>Company </TableCell>
							<TableCell>Company Type</TableCell>
							<TableCell>Email</TableCell>
							<TableCell>Phone </TableCell>
							<TableCell>Submitted</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Actions</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredRequests.length > 0 ? (
							filteredRequests.map((req, i) => (
								<motion.tr
									key={req.id}
									custom={i}
									initial="hidden"
									animate="visible"
									variants={rowVariants}
									style={{ display: 'table-row' }}
								>
									<TableCell>
										<Link href={`/vendor/product/view/${req.slug}`}>
											{req.id}
										</Link>
									</TableCell>
									<TableCell>
										{req.createdByModel === 'Vendor' ? req.company : req.name}
									</TableCell>
									<TableCell>
										{req.createdByModel === 'Vendor'
											? req.contactPerson
											: `₹${req.price}`}
									</TableCell>
									<TableCell>{req.contactEmail}</TableCell>
									<TableCell>
										{req.createdByModel === 'Vendor' ? req.phone : req.status}
									</TableCell>
									<TableCell>{req.submitted}</TableCell>
									<TableCell>
										<Chip
											label={req.productApprovelStatus}
											size="small"
											sx={{
												bgcolor:
													req.productApprovelStatus === 'APPROVED'
														? 'success.main'
														: '#e60f0fff',
												color: '#ffffffff',
												fontWeight: 500,
												textTransform: 'capitalize',
											}}
										/>
									</TableCell>
									<TableCell>
										<Box sx={{ display: 'flex', gap: 1 }}>
											{(req.productApprovelStatus as any) !== 'APPROVED' && (
												<Chip
													label={'Approve'}
													size="small"
													onClick={() =>
														handleActionClick(req._id, 'approve', req)
													}
													sx={{
														bgcolor: '#6EE7B7',
														color: '#065F46',
														cursor: 'pointer',
														fontWeight: 500,
														textTransform: 'capitalize',
														'&:hover': {
															bgcolor: 'success.main',
															color: 'white',
														},
													}}
												/>
											)}
											{(req.productApprovelStatus as any) !== 'Rejected' && (
												<Chip
													label="Reject"
													size="small"
													onClick={() =>
														handleActionClick(req._id, 'reject', req)
													}
													sx={{
														bgcolor: '#F9A8D4',
														color: '#9D174D',
														cursor: 'pointer',
														fontWeight: 500,
														'&:hover': {
															bgcolor: 'error.main',
															color: 'white',
														},
													}}
												/>
											)}
										</Box>
									</TableCell>
								</motion.tr>
							))
						) : (
							<TableRow>
								<TableCell colSpan={7} sx={{ textAlign: 'center', py: 4 }}>
									No products found
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>

			<MyModal
				loader={loader}
				open={openDialog}
				onClose={handleCancelAction}
				action={actionModal}
				onConfirm={handleApprovalAction} // ✅ reason & percentage handled
				vendorApprove={vendorApprove}
			/>

			<MySnackbarModal
				open={snackbar.open}
				Message={snackbar.message}
				action={snackbar.severity}
				onClose={() => setSnackbar({ ...snackbar, open: false })}
			/>
		</>
	);
}
